module.exports = __webpack_public_path__ + "static/media/dajianshan3.a49bfdb6.webp";